<template>
  <div id="yelpControlsID">
    <div id="yelpLinks">
      <button
        :class="{ highlightClass: Cafes }"
        type="button"
        @click="dropCoffeeMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Cafes"
      >
        <i class="fas fa-coffee"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Museums }"
        @click="dropMuseumMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Museums"
      >
        <i class="fas fa-landmark"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Volunteer }"
        @click="dropVolunteerMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Volunteer Opportunities"
      >
        <i class="fas fa-heart"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Bike }"
        @click="dropBikeShopMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Bike Shops"
      >
        <i class="fas fa-biking"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Food }"
        @click="dropRestaurantMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Food"
      >
        <i class="fas fa-utensils"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Beer }"
        @click="dropBreweryMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Beer"
      >
        <i class="fas fa-beer"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Cocktails }"
        @click="dropBarMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Cocktails"
      >
        <i class="fas fa-glass-martini-alt"></i>
      </button>
      <button
        type="button"
        :class="{ highlightClass: Farmers }"
        @click="dropFarmMarkers"
        data-toggle="tooltip"
        data-placement="top"
        title="Farmers' Markets"
      >
        <i class="fas fa-seedling"></i>
      </button>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      Cafes: false,
      Museums: false,
      Volunteer: false,
      Bike: false,
      Food: false,
      Beer: false,
      Cocktails: false,
      Farmers: false
    };
  },
  methods: {
    dropCoffeeMarkers: function() {
      this.Cafes = !this.Cafes;
      this.$store.commit("toggleActiveLayers", "coffee");
      this.$emit("dropCoffeeMarkers");
    },
    dropMuseumMarkers: function() {
      this.Museums = !this.Museums;
      this.$store.commit("toggleActiveLayers", "museums");
      this.$emit("dropMuseumMarkers");
    },
    dropVolunteerMarkers: function() {
      this.Volunteer = !this.Volunteer;
      this.$store.commit("toggleActiveLayers", "volunteer");
      this.$emit("dropVolunteerMarkers");
    },
    dropBikeShopMarkers: function() {
      this.Bike = !this.Bike;
      this.$store.commit("toggleActiveLayers", "bikeshops");
      this.$emit("dropBikeShopMarkers");
    },
    dropRestaurantMarkers: function() {
      this.Food = !this.Food;
      this.$store.commit("toggleActiveLayers", "restaurants");
      this.$emit("dropRestaurantMarkers");
    },
    dropBreweryMarkers: function() {
      this.Beer = !this.Beer;
      this.$store.commit("toggleActiveLayers", "breweries");
      this.$emit("dropBreweryMarkers");
    },
    dropBarMarkers: function() {
      this.Cocktails = !this.Cocktails;
      this.$store.commit("toggleActiveLayers", "bars");
      this.$emit("dropBarMarkers");
    },
    dropFarmMarkers: function() {
      this.Farmers = !this.Farmers;
      this.$store.commit("toggleActiveLayers", "farm");
      this.$emit("dropFarmMarkers");
    },
    directionsSearched: function() {
      this.$store.commit("toggleStateMapMode", "geolocateMode");
      this.$emit("directionsSearched");
    },
    toggleSafeRouting: function() {
      this.$store.commit("toggleSafeRouting");
      this.$emit("toggleSafeRouting");
    },
    undoLastMarker: function() {
      this.$emit("undoLastMarker");
    },
    toggleFreeDrawMode: function() {
      this.$store.commit("toggleStateFreeDrawMode");
      this.$emit("toggleFreeDrawMode");
    },
    hudDropMarker: function() {
      this.$emit("hudDropMarker"); //Hud Tells Map to Add Marker, and Map will subsequently broadcast the Marker to Vuex Store POIList
    },
    toggleCrosshair: function() {
      this.$store.commit("toggleStateMapMode");
      this.$emit("toggleCrosshair");
    },
    routeChangeFromHud: function() {
      this.$store.commit("toggleRouteProfile");
    }
  },
  mounted() {
    //Initalize Tooltips as discussed -- https://getbootstrap.com/docs/4.0/components/tooltips/
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });

    //Autohide Tooltips after being clicked -- https://stackoverflow.com/questions/25075807/auto-hide-bootstrap-tooltip
    $(function() {
      $(document).on("shown.bs.tooltip", function(e) {
        setTimeout(function() {
          $(e.target).tooltip("hide");
        }, 1000);
      });
    });
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 812px) {
  #yelpLinks {
  }
}

@media (min-width: 812px) {
  #yelpLinks {
  }
}

#yelpControlsID {
  display: flex;
  align-items: center;
}

#yelpLinks {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  width: 80%;
  height: 80%;
  align-items: center;
  justify-items: center;
  position: absolute;
  left: 0;
  right: 0;
  margin: 5px auto 0px;
  // background-color: rgba(255, 255, 255, 0.555);

  /*animations & transitions*/
  -webkit-transition: all 0.1s;
  -moz-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;

  .highlightClass {
    background-color: #797979 !important;
    border-radius: 50% !important;
    transform: scale(1.1) !important;
    border: solid 1px white;
  }

  button {
    outline: none;
    border: none;
    background: none;
    transform: scale(1.5);

    .fa-coffee {
      color: #a5a5a5;
      stroke: black;
      stroke-width: 8;
    }
    .fa-landmark {
      color: #6aa4be;
      stroke: black;
      stroke-width: 8;
    }
    .fa-heart {
      color: #c41c1c;
      stroke: black;
      stroke-width: 8;
    }
    .fa-biking {
      color: #358680;
      stroke: black;
      stroke-width: 8;
    }
    .fa-utensils {
      color: #868686;
      stroke: black;
      stroke-width: 8;
    }
    .fa-beer {
      color: #e0b72e;
      stroke: black;
      stroke-width: 8;
    }
    .fa-glass-martini-alt {
      color: #791010;
      stroke: black;
      stroke-width: 8;
    }
    .fa-seedling {
      color: #169616;
      stroke: black;
      stroke-width: 8;
    }

    &:hover {
      transform: scale(1.3);
      /*animations & transitions*/
      -webkit-transition: all 0.1s;
      -moz-transition: all 0.1s;
      -o-transition: all 0.1s;
      transition: all 0.1s;
    }
  }
}
</style>
